import type { HelpFile } from '../../types/help'
import { TriggerFullEvaluationButtonTestIds } from '../../../testids/TriggerFullEvaluationButtonTestIds'

export const triggerFullEvaluationButtonHelp: HelpFile = {
  docPage: '/docs/governance/auto-assign-rules',
  texts: {
    [TriggerFullEvaluationButtonTestIds.btnTriggerFullEvaluation]:
      'Run the start-of-day job now — evaluates every active Auto-Assign Rule against every active identity and writes the resulting changes.',
    [TriggerFullEvaluationButtonTestIds.btnTriggerFullEvaluationCancel]: null,
    [TriggerFullEvaluationButtonTestIds.btnTriggerFullEvaluationConfirm]:
      'Confirm and queue the full evaluation. The job runs on the next available scheduler slot.',
    [TriggerFullEvaluationButtonTestIds.triggerFullEvaluationDialog]:
      'Confirmation dialog before kicking off a full rule evaluation across all identities.',
  },
}
